import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '../../../ts/services/RestApiService';


export const GroupDatabasesRequestConfig: JsonRestApiRequestConfig = {
  restApiVersion: '3.9',
  httpMethod: 'POST',
  endpoint: 'databases/group',
  serverWideRequest: false,
};

export type GroupDatabasesRequestBody = {
  readonly databaseGroup: {
    readonly metadataDatabaseId: string;
    readonly database: ReadonlyArray<{
      readonly id: string;
    }>;
  };
};

export type GroupDatabasesResponse = {
  readonly database: GroupedDatabase;
};

export type GroupedDatabase = {
  readonly id: string;
  readonly name: string;
};


export function callViaApiService(body: GroupDatabasesRequestBody) {
  return makeJsonRestApiRequest<GroupDatabasesRequestBody, GroupDatabasesResponse>({
    config: GroupDatabasesRequestConfig,
    request: body,
  });
}
